import RenderComponents from '@/components/flex-content/RenderComponents'

export type FlexContentProps = {
  components: any[]
  autoSections?: boolean
  startingColor?: string
}

type sectionProps = {
  theme: string
  components: any[]
}

/**
 * --------------------------------------------------------------------------
 * FlexContent
 *
 * A wrapper for the RenderComponents function that splits components into sections
 *
 * @param {Object} components - List of components to render
 * @param {String} startingColor - Optional color to start the first section with
 * --------------------------------------------------------------------------
 **/
export default function FlexContent({ components, startingColor = 'base-0' }: FlexContentProps) {
  if (!components || !components.length) {
    return null
  }

  // Ensure we always start with a section component
  if (components[0]?.acf_fc_layout !== 'section') {
    components.unshift({
      acf_fc_layout: 'section',
      theme: startingColor,
    })
  }

  // Split components array into sections (and filter out empty sections)
  const sections = components
    .reduce((section, component) => {
      if (component.acf_fc_layout === 'section') {
        section.push({
          theme: component.theme,
          components: [],
        })
      } else {
        section[section.length - 1]?.components.push(component)
      }
      return section
    }, [])
    .filter((section) => section.components.length > 0) as sectionProps[]

  // Loop through sections and render components
  return (
    <>
      {sections.map(({ theme, components }: sectionProps, index) => {
        let sectionClass = `bg-theme text-fg theme--${theme}`
        sectionClass += theme === 'gradient-light' ? ' gradient--tri' : ''

        return (
          <section className={`section ${sectionClass}`} key={index}>
            <RenderComponents key={index} components={components} />
          </section>
        )
      })}
    </>
  )
}
